import { Shimmer } from '@components'
import { useBusinessContext } from '@context'
import { fetchAccount } from '@query'
import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { SettingsReadOnlyField } from './SettingsReadOnlyField'

interface Props {
  label: string
  accountId?: number | null
  badge?: React.ReactNode
  description?: React.ReactNode
  placeholder?: string
  layout?: 'stack' | 'row'
}

export const SettingsAccountField: React.FC<Props> = ({
  label,
  accountId,
  badge,
  description,
  placeholder,
  layout
}) => {
  const { slug } = useBusinessContext()
  const hasAccountId = Number.isInteger(accountId) && Number(accountId) > 0

  const { data: account, isLoading } = useQuery({
    queryKey: [slug, 'accounts', accountId],
    queryFn: () => fetchAccount({ slug, accountId: Number(accountId) }),
    enabled: Boolean(slug) && hasAccountId
  })

  const accountLabel = account ? `${account.number} ${account.name}` : undefined

  return (
    <SettingsReadOnlyField
      label={label}
      badge={badge}
      description={description}
      placeholder={placeholder}
      layout={layout}
      value={
        hasAccountId && isLoading ? <Shimmer width="70%" height="1rem" aria-hidden /> : accountLabel
      }
    />
  )
}
